import React from 'react'
import { Link } from 'react-router-dom'

function LinkButton({ black = false, children, fullWidth = false, ...rest }) {
    return (
        <Link
            {...rest}
            className={`transition py-4 block w-fit px-12 text-center text-xs font-medium uppercase tracking-wide ${fullWidth ? 'w-full' : null}
        rounded-full ${black ? 'bg-black text-white' : 'bg-white text-black  hover:bg-black hover:text-white border-gray-400 shadow'}`}
        >
            {children}
        </Link>
    )
}

export default LinkButton